import { FC, Fragment } from "react";
import FileHeader from "./FileHeader";
import { styled } from "@mui/material/styles";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import { FileError } from "react-dropzone";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export interface UploadErrorProps {
  file: File;
  onDelete: (file: File) => void;
  errors: FileError[];
}

const ErrorLinearProgressBar = styled(LinearProgress)(({ theme }) => ({
  [`& .${linearProgressClasses.bar}`]: {
    backgroundColor: "#DC143C",
  },
}));

const UploadError: FC<UploadErrorProps> = ({ file, onDelete, errors }) => {
  const { t } = useTranslation();
  return (
    <Fragment>
      <FileHeader file={file} onDelete={onDelete} />
      <ErrorLinearProgressBar variant="determinate" value={100} />
      {errors.map((error, index) => (
        <div key={index}>
          <Typography color="error">{t(error.code)}</Typography>
        </div>
      ))}
    </Fragment>
  );
};

export default UploadError;
